export enum AssessmentTypes {
  DAILY = 'To-Do Daily Check',
  FOLLOWUP = 'To-Do Follow-Up',
  SELFCHECK = 'Self-Check',
  HISTORY = 'History',
}

export enum ProviderAssessmentTypes {
  TODO = 'To-DO',
  SUBMITTED = 'Submitted',
  HISTORY = 'History',
}

export enum AssessmentSetupMode {
  OVERALL = 'Overall',
  SUBSCALES = 'Subscales',
  COMPONENTS = 'Components',
  CORE_MEASURES = 'CoreMeasures',
  RESULTS = 'Results',
}

export enum InstrumentTypes {
  PIX = 167,
  EVENTS = 56,
}

export enum AppliedWhen {
  ADMISSION = 1,
  DISCHARGE = 2,
  DURING = 8,
  PIX = 36,
  WEEKLY = 37,
}

export enum PixSampleTypes {
  PIX_SAMPLING = 1,
  NONE = 4,
  PIX_NO_SUBMISSION = 5,
}

export const AssessmentSortOrder: AssessmentTypes[] = [AssessmentTypes.DAILY, AssessmentTypes.FOLLOWUP, AssessmentTypes.SELFCHECK, AssessmentTypes.HISTORY];

export const getAssessmentType = (sortOrder: number): AssessmentTypes | null => {
  if (sortOrder > AssessmentSortOrder.length || sortOrder < 1) {
    return null;
  }

  return AssessmentSortOrder[sortOrder - 1];
};

/**
 * Converts the assessment setup string to the enum.
 *
 * @param modeString an instrument setup string.
 * @returns the Assessment setup mode enum.
 */
export const getAssessmentSetupMode = (modeString?: string, isResults?: boolean): AssessmentSetupMode => {
  const mode = modeString || '';
  switch (mode.toLowerCase().trim()) {
    case 'subscales':
      return AssessmentSetupMode.SUBSCALES;
    case 'components':
      return AssessmentSetupMode.COMPONENTS;
    case 'coremeasures':
      return isResults ? AssessmentSetupMode.RESULTS : AssessmentSetupMode.CORE_MEASURES;
    case 'overall':
      return isResults ? AssessmentSetupMode.RESULTS : AssessmentSetupMode.OVERALL;
    default:
      return AssessmentSetupMode.OVERALL;
  }
};

export type AssessmentSetupModeSequence = {
  mode: AssessmentSetupMode;
  subscaleSequence: number;
};

export type AssessmentAppliedWhen = {
  appliedWhenID: number;
  appliedWhen: string;
};
